module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v(_vm._s(_vm.$t('title.persons')))]), _vm._v(" "), _c('base-list', {
    attrs: {
      "model": "persons",
      "columns": ['name', 'address', 'workplace'],
      "s-model": "person"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9f3f6c20!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/person/PersonList.vue
// module id = 1026
// module chunks = 2